import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ThemePalette} from '@angular/material/core';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {Common} from '../../util/Util';

@Component({
  selector: 'app-tabs-header, greydom-tabs-header',
  templateUrl: './tabs-header.component.html',
  styleUrls: [
    '../../../../../styles/global/_management-styles.scss'
  ]
})
export class TabsHeaderComponent implements OnInit, OnDestroy, OnChanges {
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly destroyed$ = new Subject();

  textChanged$ = new Subject<string>();
  inputFormControl: FormControl;

  @Input() iconName: string;
  @Input() labelText: string;
  @Input() showButton: boolean;
  @Input() buttonText: string;
  @Input() buttonColor: ThemePalette;
  @Input() navigateTo: string;
  @Input() qaAttr: string;
  @Input() matTooltip: string;
  @Input() defaultValue: string;

  @Output() valueChanged: EventEmitter<string> = new EventEmitter();
  @Output() emitClickEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    this.buttonColor = 'accent';
    this.inputFormControl = new FormControl('');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultValue) {
      const value = changes.defaultValue.currentValue;
      this.setDefaultValue(value);
    }
  }

  ngOnInit(): void {
    this.textChanged$.pipe(
      takeUntil(this.destroyed$),
      distinctUntilChanged(),
      debounceTime(this.debounceTime)
    )
      .subscribe(
        (value: string) => {
          this.valueChanged.emit(value);
        },
        error => console.log(error));
  }

  onInputValueChanged($event: any) {
    this.textChanged$.next($event.target.value);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onClick() {
    this.emitClickEvent.next(true);
  }

  private setDefaultValue(value: string): void {
    if (!value) {
      return;
    }
    this.inputFormControl.setValue(value);
  }

}
